export default () => {
  const navigationElements = document.querySelectorAll('[component="navigation"]');

  navigationElements.forEach((navigation) => {
    const closeButton = navigation.querySelector('[child="close-button"]');
    const openButton = navigation.querySelector('[child="open-button"]');
    const contactLink = navigation.querySelector('[child="contact-link"]');
    const hotelLink = navigation.querySelector('[child="hotel-link"]');
    const currentPageLink = navigation.querySelector('.w-nav-menu .w--current');

    if (closeButton) {
      if (openButton) {
        closeButton.addEventListener('click', () => {
          openButton.click();
        });
      }
    }

    const removeClassFromOtherLinks = () => {
      const currentLinks = navigation.querySelectorAll('.w-nav-menu .w--current');
      currentLinks.forEach((element) => {
        element.classList.remove('w--current');
      });
    };

    const toggleContactSection = (toggle, link) => {
      const contactRightSection = document.querySelector('[child="contact-right-section"]');

      if (toggle) {
        contactRightSection.style.display = 'flex';
        link.classList.add('w--current');
        link.setAttribute('data-is-open', 'true');
      } else {
        contactRightSection.style.display = 'none';
        link.classList.remove('w--current');
        link.setAttribute('data-is-open', 'false');
      }
    };

    const toggleHotelSection = (toggle, link) => {
      const hotelRightSection = document.querySelector('[child="hotel-right-section"]');

      if (toggle) {
        hotelRightSection.style.display = 'flex';
        link.classList.add('w--current');
        link.setAttribute('data-is-open', 'true');
      } else {
        hotelRightSection.style.display = 'none';
        link.classList.remove('w--current');
        link.setAttribute('data-is-open', 'false');
      }
    };

    if (contactLink) {
      contactLink.addEventListener('click', () => {
        const isOpen = contactLink.getAttribute('data-is-open');

        if (isOpen === 'true') {
          toggleContactSection(false, contactLink);
          currentPageLink.classList.add('w--current');
        } else {
          removeClassFromOtherLinks();
          toggleHotelSection(false, hotelLink);
          toggleContactSection(true, contactLink);
        }
      });
    }

    if (hotelLink) {
      hotelLink.addEventListener('click', () => {
        const isOpen = hotelLink.getAttribute('data-is-open');

        if (isOpen === 'true') {
          toggleHotelSection(false, hotelLink);
          currentPageLink.classList.add('w--current');
        } else {
          removeClassFromOtherLinks();
          toggleContactSection(false, contactLink);
          toggleHotelSection(true, hotelLink);
        }
      });
    }
  });
};
